import { Routines } from '@heidi/design-system/icons';
import {
  Activity,
  BadgeCheck,
  BrainCircuit,
  CalendarDays,
  ClipboardList,
  FileText,
  FlaskConical,
  LayoutTemplate,
  Pill,
  Stethoscope,
  TriangleAlert,
  User,
  type LucideIcon,
} from 'lucide-react';

const ICON_RULES: { test: RegExp; icon: LucideIcon }[] = [
  { test: /agent\s*memory|^memory\b/i, icon: BrainCircuit },
  { test: /^routine\b|saved\s*skill/i, icon: Routines as LucideIcon },
  { test: /^template\b|document\s*template/i, icon: LayoutTemplate },
  { test: /allerg/i, icon: TriangleAlert },
  { test: /medication|medicine|med rec/i, icon: Pill },
  { test: /lab|result/i, icon: FlaskConical },
  { test: /vital|observation/i, icon: Activity },
  { test: /library\s*document|my\s*library|user\s*document/i, icon: FileText },
  { test: /attachment|attached\s*file/i, icon: FileText },
  { test: /patient\s*profile|demographics|patient\s*info/i, icon: User },
  { test: /pre[\s-]?chart/i, icon: ClipboardList },
  { test: /calendar\s*event|appointment/i, icon: CalendarDays },
  { test: /consult\s*note|session\s*note|visit/i, icon: CalendarDays },
  { test: /imaging|radiology|x[\s-]?ray|ct\b|mri\b|ultrasound/i, icon: Stethoscope },
  { test: /problem|diagnos/i, icon: ClipboardList },
  { test: /consent|compliance|identifier/i, icon: BadgeCheck },
  { test: /patient/i, icon: User },
  { test: /assessment|exam|handover|ward/i, icon: Stethoscope },
];

export const iconForSourceLabel = (label: string): LucideIcon =>
  ICON_RULES.find((rule) => rule.test.test(label))?.icon ?? FileText;

import { parseSourceGroundedLabel } from '../../../data/projects/source-grounded-label';

/** Primary title from a source label, trimmed for inline chip width. */
export const abbreviateSourceLabel = (label: string, max = 22): string => {
  const primary = parseSourceGroundedLabel(label).title;
  if (primary.length <= max) return primary;
  return `${primary.slice(0, max - 1)}…`;
};
